/*
 * «Разработчикам» — числа из макетов «Данные клиента и группы - П2» (4-В6, карточка 700)
 * и «Доступы, вебхуки, печать - П2» (4-В7, 4-В8, карточки 640): поле карточки 16, зазор 12,
 * шрифт 12.5/1.5; интеграция и адрес — рамка радиусом 10, отступ 12 × 14, зазор 8;
 * значки прав 10.5; подписи 11.5–12 вторичным цветом; ключ — тёмная плашка радиусом 10.
 */

.screen {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  font-size: 12.5px;
  line-height: 1.5;
}

.crumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  min-height: 46px;
  padding: 0 16px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
}

.crumbLink {
  padding: 0;
  font: inherit;
  color: var(--text-secondary);
  cursor: pointer;
  background: none;
  border: 0;
}

.crumbSep {
  color: var(--text-secondary);
}

.crumbTitle {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
}

.page {
  display: flex;
  justify-content: center;
  padding: 16px;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 700px;
  padding: 16px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}

.narrow {
  max-width: 640px;
  gap: 14px;
}

.head {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.headText {
  flex: 1;
  min-width: 0;
}

.title {
  margin: 0;
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
}

.sub {
  font-size: 12px;
  color: var(--text-secondary);
}

.hint {
  font-size: 11.5px;
  color: var(--text-secondary);
}

.empty {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  border: 1px dashed var(--border-strong);
  border-radius: 10px;
}

.strong {
  font-weight: var(--font-weight-semibold);
}

/* ── карточка интеграции и адреса ── */

.item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 10px;
}

.itemAlert {
  background: var(--bg-sunken);
  border-color: var(--danger-hover);
}

.itemGone {
  background: var(--bg-workspace);
  opacity: 0.75;
}

.itemHead {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.itemName {
  font-size: 13.5px;
  font-weight: var(--font-weight-semibold);
}

.itemDev {
  font-size: 11.5px;
  color: var(--text-secondary);
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.scope {
  padding: 1px 8px;
  font-size: 10.5px;
  color: var(--text-brand);
  background: var(--bg-sunken);
  border-radius: var(--radius-pill);
}

.scopePii {
  color: var(--text-on-accent);
  background: var(--text-brand);
}

.facts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
  font-size: 12px;
}

.factsSmall {
  gap: 4px 12px;
  font-size: 11.5px;
  color: var(--text-secondary);
}

.factLabel {
  color: var(--text-secondary);
}

.danger {
  font-weight: var(--font-weight-semibold);
  color: var(--danger-hover);
}

.ok {
  font-weight: var(--font-weight-semibold);
  color: var(--accent);
}

.muted {
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.actionsEnd {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.confirm {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border: 1.5px solid var(--danger-hover);
  border-radius: 10px;
}

.confirmText {
  color: var(--text-brand);
}

.url {
  overflow: hidden;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.note {
  font-size: 12px;
  line-height: 1.5;
  color: var(--text-brand);
}

.noteDanger {
  color: var(--danger-hover);
}

/* ── мастер доступа (4-В7) ── */

.steps {
  display: flex;
  gap: 6px;
}

.step {
  flex: 1;
  padding: 6px 8px;
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  text-align: center;
  background: var(--bg-sunken);
  border-radius: 6px;
}

.stepDone {
  color: var(--text-on-accent);
  background: var(--text-brand);
}

.scopeList {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.scopeRow {
  min-height: 40px;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
}

.scopeRowPii {
  background: var(--bg-sunken);
  border-color: var(--danger-hover);
}

.scopeTitle {
  font-weight: var(--font-weight-semibold);
}

.scopeTitlePii {
  color: var(--danger-hover);
}

.scopeSub {
  font-size: 11.5px;
  color: var(--text-secondary);
}

.group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.groupLabel {
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
}

.document {
  max-height: 220px;
  padding: 14px;
  overflow: auto;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-line;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 10px;
}

.secondFactor {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border: 1.5px solid var(--hold-quarantine-fg);
  border-radius: 10px;
}

.codeRow {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.code {
  width: 160px;
  height: 36px;
  padding: 0 10px;
  font: inherit;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.1em;
  color: var(--text-primary);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 8px;
}

.secret {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  color: var(--text-on-nav);
  background: var(--bg-nav);
  border-radius: 10px;
}

.secretLabel {
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.8;
}

.secretValue {
  padding: 8px 10px;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 13px;
  word-break: break-all;
  background: var(--bg-nav-hover);
  border-radius: 6px;
}

.lost {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid var(--border-strong);
  border-left: 3px solid var(--danger-hover);
  border-radius: 8px;
}

.denied {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  background: var(--bg-workspace);
  border: 1px dashed var(--border-strong);
  border-radius: 10px;
}

.problem {
  font-size: 12px;
  color: var(--danger-hover);
}

.success {
  font-size: 12px;
  color: var(--accent);
}

/* ── журнал обращений и доставки ── */

.summary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  font-size: 12px;
}

.rows {
  display: flex;
  flex-direction: column;
}

.row {
  display: grid;
  grid-template-columns: 120px 1fr auto;
  gap: 4px 12px;
  align-items: baseline;
  padding: 8px 0;
  border-bottom: 1px solid var(--border);
}

.rowTime {
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary);
}

.rowRoute {
  overflow: hidden;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rowOutcome {
  font-size: 12px;
  text-align: right;
}

.rowFailed {
  color: var(--danger-hover);
}

@media (max-width: 720px) {
  .page {
    padding: 0;
  }

  .card {
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .facts {
    grid-template-columns: 1fr;
  }

  .row {
    grid-template-columns: 1fr;
  }

  .rowOutcome {
    text-align: left;
  }
}
